<template>
    <div
        class="toggle-switch"
        :class="{
            'toggle-switch--checked': isChecked,
            'toggle-switch--disabled': disabled,
            'toggle-switch--error': hasError,
        }"
        role="checkbox"
        :aria-checked="value.toString()"
        tabindex="0"
        :disabled="disabled"
        :true-value="trueValue ? trueValue : true"
        :false-value="falseValue ? falseValue : false"
        @click="toggle"
        @keydown.space.prevent="toggle"
    >
        <span class="toggle-switch-indicator" />
    </div>
</template>

<script>
export default {
	name: 'formSwitch',
	introduction: 'VueJs toggle switch component',
	props: {
		value: {
			// v-model, if trueValue is not provided then it should be Boolean
			type: [String, Boolean, Number],
			required: true,
			default: false,
			note: 'v-model, if trueValue is not provided then it should be Boolean'
		},
		trueValue: {
			type: [String, Number],
			default: '',
			note: 'checked status value instead of boolean true, can be used without providing the falseValue (in this case the false value will be empty string)'
		},
		falseValue: {
			// unchecked status value, if needed to replace the default boolean false
			// falseValue is used only when trueValue is provided
			type: [String, Number],
			default: '',
			note: 'unchecked status value, if needed to replace the default boolean false. NOTE: falseValue cannot be used without trueValue'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Handling disabled state'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Error handling'
		},
	},
	computed: {
		isChecked() {
			if (this.trueValue) return this.value === this.trueValue;

			return this.value;
		},
	},
	methods: {
		toggle() {
			if (this.disabled) return;

			if (this.trueValue) {
				if (this.value !== this.trueValue) this.$emit('input', this.trueValue);
				else this.$emit('input', this.falseValue);
			} else {
				this.$emit('input', !this.value);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.toggle-switch {
    @width: 40px;
    @height: 22px;

    display: inline-block;
    position: relative;
    width: @width;
    height: @height;
    background-color: #000000;
    border-radius: 9999px;
    transition: background-color 0.4s ease;
    cursor: pointer;

    &:focus {
        outline: 0;
    }

    .toggle-switch-indicator {
        position: absolute;
        height: @height - 4px;
        width: @height - 4px;
        left: 2px;
        top: 50%;
        transform: translateY(-50%);
        background-color: #404040;
        border-radius: 9999px;
        transition: left 0.4s ease;
    }

    &.toggle-switch--checked {
        .toggle-switch-indicator {
            @heightMinusSpace: @height - 2px;

            background-color: #07f;
            left: ~"calc(100% - @{heightMinusSpace})";
            transition: left 0.4s ease;
        }
    }

    &.toggle-switch--disabled {
        background-color: #272626;
        cursor: not-allowed;

        .toggle-switch-indicator {
            background-color: #3d3c3c;
        }
    }

    &.toggle-switch--error {
        .toggle-switch-indicator {
            background-color: #e63f57;
        }
    }
}
</style>
